import Event from './Event';

export default class EventEmitter {
    private listeners: {[key: string]: Array<(event: Event) => void>} = {};

    public addEventListener(type: string, callback: (event: Event) => void) {
        this.listeners[type] = this.listeners[type] || [];
        this.listeners[type].push(callback);
    }

    public removeEventListener(type: string, callback: (event: Event) => void) {
        const listeners = this.listeners[type];
        if (!listeners) {
            return;
        }

        const index = listeners.indexOf(callback);
        if (index !== -1) {
            listeners.splice(index, 1);
        }
    }

    public dispatchEvent(event: Event) {
        const listeners = this.listeners[event.type] || [];
        const starListeners = this.listeners['*'] || [];
        [...listeners, ...starListeners].forEach((listener) => listener(event));
    }
}
